import * as React from 'react';

import {usePreferencesQuery, useUpdatePreferencesMutation} from 'features/users/usersApi';
import {IUserClipSearch} from 'models/users';

interface IUsePreferences {
  isFetching: boolean;
  isError: boolean;
  preferences: any;
  clipSearches: IUserClipSearch[];
  updateSavedSearches: (searchType: 'clips', searchList: IUserClipSearch[]) => Promise<void>;
}

export const usePreferences = (): IUsePreferences => {
  const {isFetching, isError, data: preferences} = usePreferencesQuery();

  const [clipSearches, setClipSearches] = React.useState<IUserClipSearch[]>([]);

  React.useEffect(() => {
    if (!preferences) {
      return;
    }

    if (preferences?.searches?.clips) {
      setClipSearches(preferences.searches.clips);
    }
  }, [preferences]);

  const [updatePreferences] = useUpdatePreferencesMutation();

  const updateSavedSearches = async (searchType: 'clips' = 'clips', searchList: IUserClipSearch[]) => {
    try {
      await updatePreferences({
        ...preferences,
        searches: {
          ...preferences?.searches,
          [searchType]: searchList,
        },
      });
    } catch (e) {}
  };

  return {
    clipSearches,
    isError,
    isFetching,
    preferences,
    updateSavedSearches,
  };
};
